import * as Sentry from '@sentry/browser';

export function initSentry() {
  const sentryData = document.getElementById('sentry_data');
  if (!sentryData) {
    console.error('Sentry data element is missing.');
    return;
  }

  const dsn = sentryData.dataset.wwwDsn;
  if (!dsn) {
    console.error('Sentry DSN is missing.');
    return;
  }

  Sentry.init({
    dsn: dsn,
    environment: sentryData.dataset.env || 'development',
  });

  Sentry.getCurrentScope().setUser({
    email: sentryData.dataset.userEmail || '',
    id: sentryData.dataset.userId || 'unknown',
  });
}

export function captureError(err) {
  Sentry.captureException(err);
}
